export const extractData = (response) => response?.data ?? response ?? null;

export const extractLinks = (response) => {
  const links = response?.links;
  if (!links || typeof links !== "object") {
    return {
      total: 0,
      per_page: 20,
      current: 1,
      prev: 0,
      next: 0,
      total_records: 0,
    };
  }

  return {
    total: Number(links.total) || 0,
    per_page: Number(links.per_page) || 20,
    current: Number(links.current) || 1,
    prev: Number(links.prev) || 0,
    next: Number(links.next) || 0,
    total_records: Number(links.total_records) || 0,
  };
};

export const hasNextPage = (links, options = {}) => {
  if (!links) return false;

  const {
    loadedCount = 0,
    lastPageSize = null,
    perPage = links.per_page || 20,
  } = options;

  // Last response was a partial page → definitely no more data
  if (lastPageSize != null && lastPageSize < perPage) return false;

  // Already loaded everything reported by the API
  if (
    links.total_records > 0 &&
    loadedCount > 0 &&
    loadedCount >= links.total_records
  ) {
    return false;
  }

  if (links.total > 0 && links.current >= links.total) return false;

  if (links.next > 0 && links.next > links.current) return true;

  if (links.current > 0 && links.total > 0 && links.current < links.total) {
    return true;
  }

  return false;
};

export const normalizeSegments = (raw) => {
  if (!raw) return {};
  if (typeof raw === "object" && !Array.isArray(raw)) {
    if (raw.segments && typeof raw.segments === "object") return raw.segments;
    return raw;
  }
  return {};
};

export const normalizeCampaigns = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.campaigns)) return raw.campaigns;
  return [];
};

const toOutcomeNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const normalizeOutcomeGroup = (group, outcomeKey) => ({
  campaigns: Array.isArray(group?.campaigns) ? group.campaigns : [],
  sent: toOutcomeNumber(group?.sent),
  [outcomeKey]: toOutcomeNumber(group?.[outcomeKey]),
  rate: toOutcomeNumber(group?.rate),
});

export const normalizeOutcomes = (raw) => {
  const data = raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};
  return {
    window_hours: toOutcomeNumber(data.window_hours) || 24,
    conversions: normalizeOutcomeGroup(data.conversions, "converted"),
    app_returns: normalizeOutcomeGroup(data.app_returns, "returned"),
    by_campaign: Array.isArray(data.by_campaign)
      ? data.by_campaign.map((row) => {
          const metric =
            row?.metric === "app_return" ? "app_return" : "conversion";
          return {
            slug: row?.slug || "",
            metric,
            sent: toOutcomeNumber(row?.sent),
            converted: toOutcomeNumber(row?.converted),
            returned: toOutcomeNumber(row?.returned),
            rate: toOutcomeNumber(row?.rate),
          };
        })
      : [],
  };
};

export const normalizeReportedPosts = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.posts)) return raw.posts;
  if (Array.isArray(raw.list)) return raw.list;
  return [];
};

export const PIE_COLORS = ["#0180F6", "#3EBF8F", "#FF5757"];
export const BAR_COLOR = "#0180F6";
